export default __webpack_public_path__ + "static/media/projectslogo.19b5a1ab.png";